<div class="row my-team">
    <div class="m-b-25 br-0 head-component">
        <div class="col-10 p-l-20 m-0 for-fixed-component br-0 head-component card">
            <div class="col-9 pl-0 card-body">
                <div class="float-left">
                    <h5 class="m-0 head-main-component">
                        {{ 'lang.userMenu.myTeam' | translate }}
                    </h5>
                    <div class="filter">

                        <span [routerLink]="['/user/my-team', {requirementType: requirementType.ByPerformanceManager, teammatePersonId: teammatePersonId, teammateEmployeeId: employeeId, isMyTeamSurveyTab: true}]"
                            routerLinkActive="filter-active" [routerLinkActiveOptions]="{exact: true}">{{ 'lang.userMenu.navigation.approveRespondents' | translate }}</span>

                        <!-- TODO: - Survey Report navigation -->
                        <!-- <span (click)="emitSurveyTabValue(true)" [ngClass] = "{'filter-active': isMyTeamSurveyTab}">{{ 'lang.userMenu.navigation.surveys'  | translate }}</span> -->
                        <span *ngIf="employeeId" [routerLink]="['/user/my-team/feedbacks', {requirementType: requirementType.ByPerformanceManager, teammatePersonId: teammatePersonId, teammateEmployeeId: employeeId, isMyTeamSurveyTab: false}]"
                            routerLinkActive="filter-active" [routerLinkActiveOptions]="{exact: true}">{{ 'lang.userMenu.navigation.feedbacks' | translate }}</span>

                        <span *ngIf="employeeId" [routerLink]="['/user/my-team/my-reports', {requirementType: requirementType.ByPerformanceManager, teammatePersonId: teammatePersonId, teammateEmployeeId: employeeId, isMyTeamSurveyTab: false}]"
                            routerLinkActive="filter-active" [routerLinkActiveOptions]="{exact: true}">{{ 'lang.userMenu.navigation.reports' | translate }}</span>
                    </div>
                </div>
                <div *ngIf="isReportOpened" class="nav justify-content-end" style="margin-top: 10px; margin-right: 10px;">
                        <button class="btn btn-outline download-pdf m-r-15" (click)="navigateToIndividualReport()">{{ getButtonTitle() | translate }}</button>
                        <div class="btn-group" dropdown>
                            <button class="btn btn-outline download-pdf dropdown-toggle" [disabled]="isPdfDownloadingInProgress"
                                id="dropdownDownloadButton" dropdownToggle aria-controls="dropdown-button">
                                {{ 'lang.reporting.downloadReport' | translate }}<span class="caret"></span></button>
                            <div role="menubar" class="dropdown-menu" id="dropdown-button" *dropdownMenu
                                aria-labelledby="dropdownDownloadButton">
                                <a class="dropdown-item" (click)="downloadIndividualPdf()">{{ 'lang.reporting.downloadIndividualReport' | translate }}</a>
                                <a class="dropdown-item" (click)="downloadSummaryPdf()">{{ 'lang.reporting.downloadSummaryReport' | translate }}</a>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
    </div>
    <div class="col-9 p-l-25">
        <router-outlet></router-outlet>
    </div>
    <div class="col-3 p-l-10">
        <div class="bg-none pl-0">
            <div class="card-body p-0">
                <div class="row info-panel">
                    <div class="col-1">
                        <i class="mdi mdi-information-outline"></i>
                    </div>
                    <div class="col-10">
                        {{ 'lang.user.userHelp' | translate }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
